import { useState } from 'react';
import { createLocation } from '../utils/practiceManagement';
import Modal from './Modal';

export default function RegisterLocation({clinicId, token, setCloseModal, onLocationAdded}) {
    const [newLocation, setNewLocation] = useState('');
    const [error, setError] = useState('');
    
   // Add a new location and re-render location list
   const handleAddLocation = async () => {
    if (!newLocation.trim()) {
        setError('Location name is required');
        return;
    } else {
        try {
            await createLocation(clinicId, newLocation, token);
            setNewLocation('');
            if (onLocationAdded) onLocationAdded();
            setCloseModal(false);
        } catch (error) {
            console.error('Error adding location', error);
            setError('Failed to add location - please try again.')
        }
    };
    }

    return (
        <Modal>
            {clinicId && (
                <>
                    <h2 className="text-xl font-bold text-docpgrPurple mb-4">add new location</h2>
                    <div className='flex gap-2'>
                        
                        <input type='text' value={newLocation} onChange={(event) => setNewLocation(event.target.value)} placeholder='enter new location name' className='flex-1 border rounded px-2 py-1' />
                        <button onClick={handleAddLocation} className='voco-gradient-hover text-white px-3 py-1 rounded ml-3'>
                            save
                        </button>
                        <button onClick={() => setCloseModal(false)} className='text-gray-500 bg-gray-200 rounded px-2 ml-3'>
                            cancel
                        </button>

                    </div>

                    {error && (
                        <div className='text-sm py-4 text-red-500'>
                          {error}
                        </div>
                    )}
                </>
            )}
        </Modal>
    )
}